import type { PublicApiKey } from '#packages/apilib';
import type { createComponentsStageModesApi } from './componentsStageModesWrapper';

export const ComponentsStageModesApiKey: PublicApiKey<
  typeof createComponentsStageModesApi
> = {
  name: 'ComponentsStageModesApi',
  public: true,
};
